module.exports = __webpack_public_path__ + "img/Documents IntelligentPDF_  RFI-crop.ec055a69.png";